import { useMutation } from '@tanstack/react-query';
import { acceptInvitation } from '../api/invitationApi';

/**
 * Mutation hook for accepting an invitation.
 *
 * Errors are handled by the global QueryClient onError (shows snackbar).
 * Callers can override with mutate(data, { onSuccess, onError }).
 */
export function useAcceptInvitation() {
  return useMutation({
    mutationFn: (invitationId: string) => acceptInvitation({ invitationId }),
  });
}
